/* eslint-disable @typescript-eslint/no-unused-vars */
import { StateId, StateMachineContext } from './types';

export class BaseState {
    public id: StateId | null = null;
    protected context: StateMachineContext;

    constructor(context: StateMachineContext) {
        this.context = context;
    }

    public *process(command: string): Generator {}
    public *onEnter(): Generator {}
    public *onExit(): Generator {}
}
